import {isPC, isTB} from './consist/config'

const hasHashParams = () => {
  if (window.location.hash !== '') {
    const $target = $('.x-hash-target')
    $('html, body').animate({
        scrollTop: $target.offset().top - 48
      },
      0);
  }
}

const init = () => {
  let _options = {
    loop: true,
    speed: 400,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: function () {
        $('.x-clamp-title-swiper').shave(70, {spaces: false})
      }
    }
  }

  if (isPC) {
    Object.assign(_options, {
      slidesPerView: 8,
      spaceBetween: 15,
    })
  } else if (isTB) {
    Object.assign(_options, {
      slidesPerView: 5,
      spaceBetween: 15,
    })
  } else {
    Object.assign(_options, {
      slidesPerView: 3,
      spaceBetween: 20,
    })
  }

  let newSwiper = new Swiper('.swiper-container', _options)

  hasHashParams()
}

const bind = () => {

}

$(function () {
  init()
  bind()
})